import React from 'react'
import { CreditCardImg1 } from '../../../helper/imagepath'

const CreditCard = ({ fieldData }) => {
  const transformDate = (input) => {
    if (!input) return 'YYYY-MM'
    const [year, week] = input.split('-')
    return `${year}-${week}`
  }

  return (
    <div className="card-container">
      <img src={CreditCardImg1} alt="Card Logo" className="card-image" />
      <div className="card-details">
        <div className="card-header"></div>
        <div className="card-number">{fieldData?.card_number || 'XXXX XXXX XXXX XXXX'}</div>
        <div className="card-info">
          <div>
            <div className="label">Cardholder Name</div>
            <div className="cardholder-name">{fieldData?.card_holder || '------------------------'}</div>
          </div>
          <div>
            <div className="label">Valid</div>
            <div className="expiry-date">{fieldData?.expired_at ? transformDate(fieldData?.expired_at) : 'YYYY-MM'}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreditCard
